exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container.new-trip,\r\n.app-container.new-trip main,\r\n.app-container.new-trip #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.new-trip .view-container {\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.new-trip .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
